<template>
    <div class="box-text">
        <van-cell center :title="item.title" :value="item.data|result" />
    </div>
</template>
<script>
import Vue from 'vue';
import { Icon,Cell } from 'vant';
Vue.use(Cell);
Vue.use(Icon);
export default {
    name:"CheckBox",
    props:{
        item:{
            type:Object
        }
    },
    filters:{
        result(data){
            let str = ''
            data.forEach(item=>{
                str+=item+';'
            })
            return str
        }
    },
    data(){
        return{

        }
    }
}
</script>
<style lang="less">

</style>